import React from "react";
import { changeParameter } from "../../../api_calls/TableauVisuals";
import { Box } from "@mui/material";
import SelectBox from "../Selectors/SelectBox";
import SingleSelect from "../Selectors/SingleSelect";
import { updateStateData } from "../../../Store/actions";
import { useDispatch, useSelector } from "react-redux";

const checkoutDataOptions = [
    {
        value:"cap_counter",
        label:"CAP Counter"
    },
    {
        value:"cap_counter_no_outlier",
        label:"CAP Counter w/o Outliers"
    },
    {
        value:"basket_trolley",
        label:"Basket Trolley"
    },
    {
        value:"only_trolley",
        label:"Only Trolley"
    },
    {
        value:"trigger_witness_conversion",
        label:"Trigger Witness Conversion"
    },
    {
        value:"contact_cr",
        label:"Contact CR"
    },
    {
        value:"referencing",
        label:"Referencing"
    }
];

const CheckoutDataFilter = ({ reduxKeywordToSaveValue }) => {
    const userStateData = useSelector((state) => state.userSelections);
    const dispatchAction = useDispatch();
    const [checkoutTypeSelection, setCheckoutTypeSelection] = React.useState({});
    const [dataLoaded, setDataLoaded] = React.useState(false);

    React.useEffect(() => {
        // sort options based on label in ascending order
        checkoutDataOptions.sort((a, b) => a.label.localeCompare(b.label));
        setCheckoutTypeSelection(checkoutDataOptions[0]);

        setTimeout(() => {
            setDataLoaded(true);
        }, 1000);
    }, []);

    return dataLoaded ? (
        <Box sx={{ width: 220 }}>
            <SingleSelect
                enableFullWidth={true}
                label={"Checkout Data"}
                disableSearch={true}
                selectionCheck={(option, value) => option.label === value.label}
                options={checkoutDataOptions}
                defaultVal={checkoutTypeSelection}
                onChangeCall={(selectedOption) => {
                    setCheckoutTypeSelection(selectedOption);
                    dispatchAction(
                        updateStateData({
                            [reduxKeywordToSaveValue]: {
                                ...userStateData[reduxKeywordToSaveValue],
                                "checkout_data": selectedOption.value,
                            },
                        })
                    );
                }}
            />
        </Box>
    ) : (
        <></>
    );
};

export default CheckoutDataFilter;
